import { render, staticRenderFns } from "./ApprovalTasksModal.vue?vue&type=template&id=35d10ff6&"
import script from "./ApprovalTasksModal.vue?vue&type=script&lang=js&"
export * from "./ApprovalTasksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports